import { doesExist } from '../../../Common/utils/GameUtils';
import React from 'react'
import { useSelector } from 'react-redux'

export default function useMyPlayerSeat(tempTableId) {
    const clientSeat = useSelector((state) => state.gameTable.games[tempTableId].playerSeat);
    const playerData = useSelector((state) => state.gameTable.games[tempTableId].playerData.find((player) => player.position === clientSeat));

    if (!playerData || !doesExist(clientSeat)) {
        console.warn('Player Data or Client Seat missing in useMyPlayerSeat hook ', playerData, clientSeat);
        return {};
    }

    return playerData;
}
